const lineHeightFor = (lineHeights, fontSize) => {
  for (const [upperBound, lineHeight] of Object.entries(lineHeights)) {
    if (fontSize < parseInt(upperBound, 10)) {
      return Math.round(lineHeight * fontSize)
    }
  }
}

export const legacyLineHeightFor = (fontSize) => {
  const lineHeightInEms = fontSize < 32 ? 1.25 : 1
  return Math.floor(lineHeightInEms * fontSize)
}

export default lineHeightFor
